{
  "1 à 5": "1 a 5",
  "A chassé le plus de bad vibes": "Ahuyentó a más bad vibes",
  "A chassé les boss": {
    "one": "Ahuyentó al jefe",
    "many": "Ahuyentó a los jefes",
    "other": "Ahuyentó a los jefes"
  },
  "A ramassé le plus de vibes": "Recogió más vibes",
  "A relevé l’équipe": "Levantó al equipo",
  "Agir": "Acciones",
  "Agrès": "Aparatos",
  "Alliés soignés": "Aliados curados",
  "Alt": "Alt",
  "Alt Gr": "Alt Gr",
  "Ambyss": "Ambyss",
  "Anneaux solaires": "Anillos solares",
  "Apprendre à jouer": "Aprender a jugar",
  "Approche une bad vibe : tu tires tout seul": "Acércate a una bad vibe: disparas solo",
  "Appuie sur Entrée ou sur A pour rejoindre": "Pulsa Enter o A para unirte",
  "Appuie…": "Pulsa…",
  "Après chaque kick, trois étincelles qui transpercent.": "Tras cada kick, tres chispas que atraviesan.",
  "Après le dernier boss, la nuit continue": "Tras el último jefe, la noche sigue",
  "Arc-en-ciel du drop": "Arcoíris del Drop",
  "Assiettes chinoises": "Platos Chinos",
  "Attire": "Atrae",
  "Aucun salon ne porte ce code": "Ninguna sala tiene este código",
  "Automatique": "Automático",
  "Autre": "Otro",
  "Avant de lancer": "Antes de empezar",
  "Avec tes amis": "Con tus amigos",
  "B2B : {recipe}": "B2B: {recipe}",
  "Backstage": "Backstage",
  "Bad vibes": "Bad vibes",
  "Bad vibes dissipées": "Bad vibes disipadas",
  "Baisser le son": "Bajar el sonido",
  "Balaie la foule de loin avec ses poi lumineux. Fragile.": "Barre a la multitud desde lejos con sus poi luminosos. Frágil.",
  "Balaie un arc d'une ligne de lumière qui dissout les bad vibes.": "Barre un arco con una línea de luz que disuelve a las bad vibes.",
  "Banane": "Riñonera",
  "Bas": "Abajo",
  "Baskets légères": "Zapatillas Ligeras",
  "Bonnes ondes": "Buenas Ondas",
  "Boss": "Jefes",
  "Boss vaincu": "Jefe derrotado",
  "Boucle VJ": "Bucle VJ",
  "Boule à facettes": "Bola de Espejos",
  "Bouton {number}": "Botón {number}",
  "Boutons par défaut remis.": "Botones por defecto restaurados.",
  "Bras grands ouverts": "Brazos Bien Abiertos",
  "Break": "Break",
  "Brume du lac": "Bruma del Lago",
  "Bug": "Bug",
  "Bâton de feu": "Bastón de Fuego",
  "Bâton du diable": "Devil Stick",
  "Caisson de basse": "Subwoofer",
  "Ce bouton garde son rôle, choisis-en un autre.": "Este botón conserva su función, elige otro.",
  "Ce code est déjà pris, réessaie": "Este código ya está en uso, inténtalo otra vez",
  "Ce code n’est pas valide": "Este código no es válido",
  "Ce que tu as vécu, ce que tu attendais, ce que tu changerais.": "Lo que viviste, lo que esperabas, lo que cambiarías.",
  "Cerceaux": "Aros",
  "Cette touche garde son rôle, choisis-en une autre.": "Esta tecla conserva su función, elige otra.",
  "Chacun prend une place avec son clavier ou sa manette.": "Cada uno ocupa un sitio con su teclado o su mando.",
  "Chaque dash laisse ta traînée au sol deux mesures.": "Cada dash deja tu estela en el suelo dos compases.",
  "Charge": "Embestida",
  "Choisi": "Elegida",
  "Choisir": "Elegir",
  "Choisir la scène": "Elegir el escenario",
  "Choisir un piège": "Elegir una trampa",
  "Choisis d’abord le type de ton avis.": "Elige primero de qué trata tu opinión.",
  "Choisis la scène": "Elige el escenario",
  "Choisis tes touches et tes boutons": "Elige tus teclas y botones",
  "Choisis ton amélioration": "Elige tu mejora",
  "Choisis ton perso": "Elige tu personaje",
  "Choix de la scène": "Elección del escenario",
  "Choix du perso": "Elección del personaje",
  "Choix d’amélioration": "Elección de mejora",
  "Classe": "Clase",
  "Classe précédente": "Clase anterior",
  "Classe suivante": "Clase siguiente",
  "Classe · {className}": "Clase · {className}",
  "Classes": "Clases",
  "Clavier et souris": "Teclado y ratón",
  "Clic droit": "Clic derecho",
  "Clic gauche": "Clic izquierdo",
  "Clic molette": "Clic central",
  "Code du salon": "Código de la sala",
  "Colle le code ici": "Pega el código aquí",
  "Connexion impossible ({message})": "No se puede conectar ({message})",
  "Connexion perdue": "Conexión perdida",
  "Console de mixage": "Mesa de Mezclas",
  "Contexte de la partie": "Contexto de la partida",
  "Contrôles": "Controles",
  "Copie impossible ici. Ton avis reste dans l’onglet GitHub.": "Aquí no se puede copiar. Tu opinión sigue en la pestaña de GitHub.",
  "Copie impossible ici. Ton texte est sélectionné : copie-le à la main.": "Aquí no se puede copiar. Tu texto está seleccionado: cópialo a mano.",
  "Copier": "Copiar",
  "Copier le lien": "Copiar el enlace",
  "Copié dans le presse-papiers.": "Copiado al portapapeles.",
  "Coupé": "Silenciado",
  "Croix": "Cruceta",
  "Crée un salon pour inviter tes amis, ou rejoins le leur avec son code.": "Crea una sala para invitar a tus amigos, o únete a la suya con su código.",
  "Créer un salon": "Crear una sala",
  "Ctrl": "Ctrl",
  "Ctrl droite": "Ctrl derecho",
  "Câble d'or": "Cable de Oro",
  "C’est plutôt": "Es más bien",
  "Dash": "Impulso",
  "Debout": "En pie",
  "Des spores, à porter à un géant": "Esporas, para llevar a un gigante",
  "Deux bâtons frappent tout autour de toi à chaque temps.": "Dos bastones golpean a tu alrededor en cada tiempo.",
  "Deux éventails tournent autour de toi sans jamais s’arrêter.": "Dos abanicos giran a tu alrededor sin parar nunca.",
  "Deuxième souffle": "Segundo Aire",
  "Diabolo": "Diábolo",
  "Didacticiel": "Tutorial",
  "Double bâton": "Doble Bastón",
  "Double faisceau": "Doble Haz",
  "Double tempo": "Doble Tempo",
  "Downtempo, dub": "Downtempo, dub",
  "Droite": "Derecha",
  "Drop": "Drop",
  "Débriefe ton set sur Discord": "Comenta tu set en Discord",
  "Début": "Inicio",
  "Défends le sound system jusqu’au lever du soleil.": "Defiende el sound system hasta el amanecer.",
  "Défense": "Defensa",
  "Départ": "Salida",
  "Déplace-toi": "Muévete",
  "Elle vide l'énergie de tout ce qui brille.": "Vacía la energía de todo lo que brilla.",
  "En attente de l’hôte": "Esperando al anfitrión",
  "En attente de {players}": "Esperando a {players}",
  "En attente d’un joueur": "Esperando a un jugador",
  "En ligne": "En línea",
  "En ligne, la pause n’arrête pas le set : ton personnage reste immobile pendant que les autres jouent.": "En línea, la pausa no detiene el set: tu personaje se queda quieto mientras los demás juegan.",
  "Enceintes": "Altavoces",
  "Enceintes branchées": "Altavoces conectados",
  "Entrée": "Enter",
  "Envoie le code ou le lien à tes amis, puis lance le set.": "Manda el código o el enlace a tus amigos y luego lanza el set.",
  "Envoie une onde de basse sur chaque temps et repousse les bad vibes.": "Lanza una onda de bajo en cada tiempo y empuja a las bad vibes.",
  "Envoyer sur GitHub": "Enviar a GitHub",
  "Espace": "Espacio",
  "Fais un dash": "Haz un impulso",
  "Fermer": "Cerrar",
  "Fin": "Fin",
  "Fin de partie": "Fin de la partida",
  "Frappe autour": "Golpea alrededor",
  "Frappe devant": "Golpea delante",
  "Frappe loin": "Golpea lejos",
  "Frisbee": "Frisbi",
  "Frisbees en passes": "Pases de Frisbi",
  "Full festival": "Full festival",
  "Fusion": "Fusión",
  "Gauche": "Izquierda",
  "Glisse sur l’arène pour te déplacer": "Arrastra por la arena para moverte",
  "Glisser son bouton": "Arrastrar su botón",
  "Glisser sur l’arène": "Arrastrar por la arena",
  "Goa des étoiles": "Goa de las Estrellas",
  "Générique": "General",
  "Haut": "Arriba",
  "Hôte": "Anfitrión",
  "Idée": "Idea",
  "Il attire les bad vibes, puis les repousse d’une onde.": "Atrae a las bad vibes y luego las empuja con una onda.",
  "Il enrôle les bad vibes en ronde autour de lui : elles prennent les coups.": "Enrola a las bad vibes en un corro a su alrededor: ellas se llevan los golpes.",
  "Il filme la scène et éblouit doucement la zone de son écran.": "Graba el escenario y deslumbra suavemente la zona de su pantalla.",
  "Il fonce droit sur la scène et bouscule qui se met en travers.": "Va directo al escenario y empuja a quien se cruce.",
  "Il fonce sur tes vibes au sol, les vole, puis détale si tu le poursuis.": "Corre a por tus vibes del suelo, las roba y sale huyendo si lo persigues.",
  "Il frappe en arc devant toi à chaque temps.": "Golpea en arco delante de ti en cada tiempo.",
  "Il frappe à l’aller, revient soigner un allié.": "Golpea a la ida y vuelve para curar a un aliado.",
  "Il ne va pas bien : reste à son contact une mesure pour l'aider.": "No está bien: quédate a su lado un compás para ayudarlo.",
  "Il reste loin et balance des bouteilles qui ralentissent qui les reçoit.": "Se queda lejos y lanza botellas que frenan a quien las recibe.",
  "Il s'accroche à toi et te ralentit jusqu'à ce qu'on le décroche.": "Se te pega y te frena hasta que alguien te lo quite de encima.",
  "Il souffle, et tout ce qui est léger dérive.": "Sopla, y todo lo ligero se va a la deriva.",
  "Il surgit de partout à la fois, faible seul mais jamais seul.": "Aparece por todas partes a la vez, débil solo pero nunca solo.",
  "Il va plus loin et plus vite, puis revient soigner un allié.": "Llega más lejos y más rápido, y vuelve para curar a un aliado.",
  "Il veut couper le son avant l'heure.": "Quiere cortar el sonido antes de hora.",
  "Il éteint les bonus de qui reste trop près : vise-le en priorité.": "Apaga las mejoras de quien se queda demasiado cerca: apúntale primero.",
  "Inser": "Insert",
  "Interruption": "Interrupción",
  "Inverser les sticks": "Invertir los sticks",
  "Invité": "Invitado",
  "Jambes de danseur": "Piernas de Bailarín",
  "Jauge": "Indicador",
  "Jeu complet": "Juego completo",
  "Jeu web léger de survie coopérative dans un festival de psytrance.": "Juego web ligero de supervivencia cooperativa en un festival de psytrance.",
  "Joindre le contexte": "Adjuntar el contexto",
  "Joue en continu": "Suena sin parar",
  "Jouer": "Jugar",
  "Joueur {number}": "Jugador {number}",
  "Jusqu’à 4 joueurs": "Hasta 4 jugadores",
  "Kiff": "Disfrute",
  "L'Arnaqueur": "El Estafador",
  "L'Hygie": "La Hygie",
  "L'Intolérant": "El Intolerante",
  "La Batterie à plat": "La Batería Agotada",
  "La Forêt": "El Bosque",
  "La Grenouille acide": "La Rana Ácida",
  "La Luxiole": "La Luxiole",
  "La musique s’arrête": "La música se para",
  "La partie a déjà commencé": "La partida ya ha empezado",
  "La piste t’attend": "La pista te espera",
  "La soirée d'ouverture": "La Noche de Apertura",
  "Lance le set": "Lanza el set",
  "Lance ta spéciale": "Lanza tu especial",
  "Lancer la nuit": "Lanzar la noche",
  "Lancer le festival": "Lanzar el festival",
  "Lancer le set": "Lanzar el set",
  "Lancé sur le 1, il retombe sur les bad vibes et claque.": "Lanzado en el 1, cae sobre las bad vibes y estalla.",
  "Langue": "Idioma",
  "Langues du jeu": "Idiomas del juego",
  "Laser": "Láser",
  "Le Babacool": "El Jipi",
  "Le Bavard": "El Charlatán",
  "Le Cercle acid": "El Círculo Acid",
  "Le Circadien": "El Circadiano",
  "Le Collant": "El Pegajoso",
  "Le Coup de vent": "La Ráfaga",
  "Le Couvre-feu": "El Toque de Queda",
  "Le Céleste": "El Celeste",
  "Le Dome": "El Dome",
  "Le Désagréable": "El Borde",
  "Le Dôme chill": "La Cúpula Chill",
  "Le Fatigué": "El Dormilón",
  "Le Festivalier en détresse": "El Festivalero en Apuros",
  "Le Filmeur": "El Grabador",
  "Le Jongleur": "El Malabarista",
  "Le Kiffeur": "El Disfrutón",
  "Le Mâle alpha": "El Macho Alfa",
  "Le Méprisant": "El Despectivo",
  "Le Nounours": "El Nounours",
  "Le Pogo": "El Pogo",
  "Le Poussin": "El Pollito",
  "Le Random": "El Random",
  "Le Sportif": "El Deportista",
  "Le Sub": "El Sub",
  "Le Super fan": "El Superfán",
  "Le Tatoué": "El Tatuado",
  "Le Veilleur aux lucioles": "El Guardián de Luciérnagas",
  "Le Zombie": "El Zombi",
  "Le boss lâche une relique": "El jefe suelta una reliquia",
  "Le formulaire GitHub est ouvert": "El formulario de GitHub está abierto",
  "Le jeu se recharge": "El juego se recarga",
  "Le lien avec les autres joueurs est coupé.": "Se ha cortado la conexión con los demás jugadores.",
  "Le lève-tôt du petit matin : abats-le, il se relève une fois.": "El madrugador del amanecer: derríbalo, se levanta una vez.",
  "Le poser ailleurs": "Ponerla en otro sitio",
  "Le salon existe, mais vos réseaux n’arrivent pas à se joindre": "La sala existe, pero vuestras redes no consiguen conectarse",
  "Le set continue": "El set sigue",
  "Le set est allé au bout, puis le sound system a tenu {duration} de sans-fin. On y retourne ?": "El set llegó al final y el sound system aguantó {duration} de modo sin fin. ¿Otra vez?",
  "Le set reprend là où tu l’as laissé.": "El set sigue donde lo dejaste.",
  "Le set se joue en paysage.": "El set se juega en horizontal.",
  "Le set s’arrête pour tout le monde plutôt que de continuer de travers. Le rapport est prêt pour « Ton avis ».": "El set se para para todos en vez de seguir descompasado. El informe está listo en «Tu opinión».",
  "Le set s’arrête pour toute l’équipe, sans score : chacun peut changer de perso.": "El set se detiene para todo el equipo, sin puntuación: cada uno puede cambiar de personaje.",
  "Le set va jusqu’au dernier boss, puis la nuit repart : elle s’arrête quand vous tombez.": "El set llega hasta el último jefe y luego la noche arranca de nuevo: se acaba cuando caéis.",
  "Le soleil se lève sur le dancefloor. Le sound system a tenu toute la nuit.": "Sale el sol sobre la pista. El sound system aguantó toda la noche.",
  "Le sound system tient bon, mais les bad vibes ont vidé la piste. On se relève et on y retourne ?": "El sound system aguanta, pero las bad vibes vaciaron la pista. ¿Nos levantamos y otra vez?",
  "Le totem envoie une onde sur chaque kick.": "El tótem lanza una onda en cada kick.",
  "Les autres scènes suivent : à chaque sunrise, l’équipe choisit sa sortie.": "Los demás escenarios siguen: en cada sunrise, el equipo elige su salida.",
  "Les bad vibes ont eu raison du sound system. On rebranche et on y retourne ?": "Las bad vibes pudieron con el sound system. ¿Lo volvemos a enchufar y otra vez?",
  "Les bad vibes qu’il traverse encaissent plus de coups.": "Las bad vibes que atraviesa reciben más daño.",
  "Les bad vibes y ralentissent": "Allí las bad vibes van más lentas",
  "Les bad vibes y sont marquées": "Allí las bad vibes quedan marcadas",
  "Les deux versions de la partie ont divergé": "Las dos copias de la partida se han desincronizado",
  "Les joueurs": "Los jugadores",
  "Les lucioles veillent sur toi": "Las luciérnagas velan por ti",
  "Les pièges freinent les bad vibes": "Las trampas frenan a las bad vibes",
  "Les quatre scènes, d’un chemin à l’autre": "Los cuatro escenarios, de camino en camino",
  "Libre": "Libre",
  "Lien copié, envoie-le à tes amis.": "Enlace copiado, mándaselo a tus amigos.",
  "Lien sélectionné : copie-le avec Ctrl+C.": "Enlace seleccionado: cópialo con Ctrl+C.",
  "Line-up": "Line-up",
  "Lourd et sûr de lui, il pousse ton matériel et encaisse moitié moins de face : prends-le à revers.": "Pesado y creído, empuja tu equipo y recibe la mitad de daño de frente: atácalo por detrás.",
  "Lumière traversante": "Luz Penetrante",
  "Légendaire": "Legendaria",
  "L’Avatar": "El Avatar",
  "L’Enraciné": "El Enraizado",
  "L’after": "El after",
  "L’hôte a fermé le salon": "El anfitrión ha cerrado la sala",
  "L’hôte a quitté le set": "El anfitrión ha dejado el set",
  "L’hôte choisit la scène": "El anfitrión elige el escenario",
  "L’équipe": "El equipo",
  "Machine à fumée": "Máquina de Humo",
  "Main libre": "Mano libre",
  "Main stage": "Main stage",
  "Maj": "Mayús",
  "Maj droite": "Mayús derecho",
  "Maj+Tab": "Mayús+Tab",
  "Manette": "Mando",
  "Manette {number}": "Mando {number}",
  "Marcher au stick droit, viser au gauche": "Andar con el stick derecho, apuntar con el izquierdo",
  "Marque": "Marca",
  "Menu de pause": "Menú de pausa",
  "Menu principal": "Menú principal",
  "Mode calme": "Modo tranquilo",
  "Mode calme, commandes, langue": "Modo tranquilo, controles, idioma",
  "Mode de jeu": "Modo de juego",
  "Molette": "Rueda",
  "Molette ↑": "Rueda ↑",
  "Molette ↓": "Rueda ↓",
  "Monocycle": "Monociclo",
  "Monocycle filant": "Monociclo Fugaz",
  "Monocycle réparateur": "Monociclo Reparador",
  "Monter le son": "Subir el sonido",
  "Montée": "Subida",
  "Musique et effets": "Música y efectos",
  "Même écran": "Misma pantalla",
  "Même écran ou en ligne": "Misma pantalla o en línea",
  "Ne vise pas, il danse : sa bonne humeur frappe tout autour de lui et fait tirer plus vite.": "No apunta, baila: su buen humor golpea todo a su alrededor y hace disparar más rápido.",
  "Niv. {level}": "Nv. {level}",
  "Niveau": "Nivel",
  "Niveau supérieur": "Subes de nivel",
  "Niveau {level}": "Nivel {level}",
  "Niveau {level} : {vibes} vibes sur {next}": {
    "one": "Nivel {level}: {vibes} de {next} vibe",
    "many": "Nivel {level}: {vibes} de {next} vibes",
    "other": "Nivel {level}: {vibes} de {next} vibes"
  },
  "Niveau {level} sur {max}": "Nivel {level} de {max}",
  "Nom": "Nombre",
  "Nom du joueur {number}": "Nombre del jugador {number}",
  "Non": "No",
  "Nouveau": "Nuevo",
  "Nouveau record !": "¡Nuevo récord!",
  "Nova": "Nova",
  "Ola": "Ola",
  "Ola déchaînée": "Ola Desatada",
  "Ola sans fin": "Ola Sin Fin",
  "Oui": "Sí",
  "Page ↑": "Pág ↑",
  "Page ↓": "Pág ↓",
  "Palier {tier} / {count}": "Fase {tier} / {count}",
  "Palier {tier}, drop": "Fase {tier}, drop",
  "Par où commence la nuit ?": "¿Por dónde empieza la noche?",
  "Partie interrompue": "Partida interrumpida",
  "Pas chassé": "Paso Chassé",
  "Pas de compte GitHub ? Copie ton avis pour l’envoyer autrement.": "¿Sin cuenta de GitHub? Copia tu opinión para enviarla de otra forma.",
  "Pas de réponse : réessaie, ou vérifie le code": "Sin respuesta: inténtalo otra vez o revisa el código",
  "Pas sur GitHub ?": "¿No estás en GitHub?",
  "Passe dans les coulisses sur Discord": "Pásate por el backstage en Discord",
  "Pause": "Pausa",
  "Pavé {number}": "Num {number}",
  "Phrases tenues": "Frases aguantadas",
  "Piège précédent": "Trampa anterior",
  "Piège suivant": "Trampa siguiente",
  "Pièges": "Trampas",
  "Place {place} sur {slots}": "Hueco {place} de {slots}",
  "Pluie de diabolos": "Lluvia de Diábolos",
  "Plus aucun signe de l’hôte depuis {seconds} secondes.": {
    "one": "Ni rastro del anfitrión desde hace {seconds} segundo.",
    "many": "Ni rastro del anfitrión desde hace {seconds} segundos.",
    "other": "Ni rastro del anfitrión desde hace {seconds} segundos."
  },
  "Plus de place pour un piège : reprends-en un": "No queda hueco para otra trampa: recoge una",
  "Plus personne debout": "Nadie queda en pie",
  "Portée": "Alcance",
  "Pose ton mot sur Discord": "Deja tu mensaje en Discord",
  "Pose un piège": "Pon una trampa",
  "Poser le piège": "Poner la trampa",
  "Poser un piège à ses pieds": "Poner una trampa a tus pies",
  "Pour rejouer ta partie à l’identique": "Para repetir tu partida tal cual",
  "Progressive": "Progressive",
  "Projecteur de poursuite": "Foco de Seguimiento",
  "Prêt": "Listo",
  "Prête": "Lista",
  "Psychill, ambient": "Psychill, ambient",
  "Psytrance full-on": "Psytrance full-on",
  "Pumpui": "Pumpui",
  "Quelle nuit !": "¡Menuda noche!",
  "Qui monte sur la piste ce soir ?": "¿Quién sale a la pista esta noche?",
  "Quitter": "Salir",
  "Quitter la partie": "Salir de la partida",
  "Quitter le salon": "Salir de la sala",
  "Quitter le set ?": "¿Dejar el set?",
  "Raconte-nous ta soirée": "Cuéntanos tu noche",
  "Ralentit": "Frena",
  "Rallonge": "Alargador",
  "Ramasse les vibes": "Recoge las vibes",
  "Rang {rank}": "Rango {rank}",
  "Rang {rank} sur {max}": "Rango {rank} de {max}",
  "Rare": "Rara",
  "Recharge": "Recarga",
  "Recharge la page": "Recarga la página",
  "Record : {score}": "Récord: {score}",
  "Recrute tes roadies sur Discord": "Recluta a tus roadies en Discord",
  "Rejoindre": "Unirse",
  "Rejouer": "Jugar otra vez",
  "Relique": "Reliquia",
  "Relis ton avis dans le nouvel onglet, puis publie-le. Il te faut un compte GitHub.": "Repasa tu opinión en la nueva pestaña y publícala. Necesitas una cuenta de GitHub.",
  "Remettre par défaut": "Restablecer",
  "Remplace {weapon}": "Reemplaza {weapon}",
  "Remplis ta jauge de vibes, puis choisis une amélioration": "Llena tu indicador de vibes y luego elige una mejora",
  "Repousse": "Empuja",
  "Reprendre": "Continuar",
  "Reprendre : {trap}": "Recoger: {trap}",
  "Reste deux mesures pour brancher": "Quedan dos compases para conectar",
  "Reste près d’une enceinte pour la brancher": "Quédate cerca de un altavoz para conectarlo",
  "Reste quatre mesures pour brancher": "Quedan cuatro compases para conectar",
  "Reste trois mesures pour brancher": "Quedan tres compases para conectar",
  "Reste une mesure pour brancher": "Queda un compás para conectar",
  "Reste zéro mesure pour brancher": "No queda ningún compás para conectar",
  "Reste {bars} mesures pour brancher": {
    "one": "Queda {bars} compás para conectar",
    "many": "Quedan {bars} compases para conectar",
    "other": "Quedan {bars} compases para conectar"
  },
  "Rester": "Quedarse",
  "Retour": "Atrás",
  "Retour arrière": "Retroceso",
  "Retour au perso": "Volver al personaje",
  "Retour au salon": "Volver a la sala",
  "Retour au salon ?": "¿Volver a la sala?",
  "Retour au titre": "Volver al título",
  "Ruban arc-en-ciel": "Cinta Arcoíris",
  "Réessayer": "Reintentar",
  "Réglages": "Ajustes",
  "Salon": "Sala",
  "Salon en ligne": "Sala en línea",
  "Salon local": "Sala local",
  "Salon plein": "Sala llena",
  "Sans fin": "Sin fin",
  "Sans lui, le sound system s’éteint.": "Sin él, el sound system se apaga.",
  "Sans strobos, secousses ni halos forts": "Sin estrobos, temblores ni halos",
  "Sans tenir le tir": "Sin mantener el disparo",
  "Score": "Puntuación",
  "Scène": "Escenario",
  "Scène du départ": "Escenario de salida",
  "Scènes": "Escenarios",
  "Se déplacer": "Moverse",
  "Ses bulles de blabla s'affichent et masquent un bout de ton écran.": "Sus bocadillos de cháchara aparecen y tapan parte de tu pantalla.",
  "Ses zones freinent les bad vibes et soignent tes alliés.": "Sus zonas frenan a las bad vibes y curan a tus aliados.",
  "Soigne": "Cura",
  "Soigne, répare la scène et relève ses amis.": "Cura, repara el escenario y levanta a sus amigos.",
  "Soin": "Curación",
  "Son": "Sonido",
  "Son bâillement se propage autour de lui, puis il s'endort sur place.": "Su bostezo se contagia a su alrededor y luego se duerme ahí mismo.",
  "Son des coups": "Sonido de golpes",
  "Sono de référence": "Equipo de Referencia",
  "Souffle un cône de brume qui balaie la piste, soigne sur chaque temps et ralentit les bad vibes.": "Sopla un cono de bruma que barre la pista, cura en cada tiempo y frena a las bad vibes.",
  "Souris": "Ratón",
  "Spéciale": "Especial",
  "Spéciale XXL": "Especial XXL",
  "Stick droit": "Stick derecho",
  "Stick gauche": "Stick izquierdo",
  "Sub renforcé": "Sub Reforzado",
  "Sunrise": "Sunrise",
  "Sunrise !": "¡Sunrise!",
  "Sur le drop, il traverse tout l’écran et marque tout.": "En el drop, cruza toda la pantalla y lo marca todo.",
  "Sur le drop, une pluie de diabolos tombe sur tout l’écran.": "En el drop, cae una lluvia de diábolos por toda la pantalla.",
  "Ta Ola frappe deux fois plus fort.": "Tu ola golpea el doble de fuerte.",
  "Ta Ola frappe plus fort.": "Tu ola golpea más fuerte.",
  "Ta Ola frappe trois fois plus fort.": "Tu ola golpea el triple de fuerte.",
  "Ta spéciale frappe deux fois plus fort.": "Tu especial golpea el doble de fuerte.",
  "Ta spéciale frappe plus fort.": "Tu especial golpea más fuerte.",
  "Ta spéciale frappe trois fois plus fort.": "Tu especial golpea el triple de fuerte.",
  "Ta spéciale revient bien plus vite.": "Tu especial vuelve mucho antes.",
  "Ta spéciale revient plus vite.": "Tu especial vuelve antes.",
  "Ta spéciale revient presque aussitôt.": "Tu especial vuelve casi al instante.",
  "Ta spéciale revient presque en continu.": "Tu especial vuelve casi sin pausa.",
  "Tactile": "Táctil",
  "Talkie-walkie": "Walkie-Talkie",
  "Temps": "Tiempo",
  "Tes agrès : {places}": "Tus aparatos: {places}",
  "Tes pièges font deux fois et demie plus de dégâts.": "Tus trampas hacen dos veces y media más daño.",
  "Tes pièges font deux fois plus de dégâts.": "Tus trampas hacen el doble de daño.",
  "Tes pièges font plus de dégâts.": "Tus trampas hacen más daño.",
  "Tes pièges frappent fort et loin, et tes loots abondent.": "Tus trampas pegan fuerte y lejos, y el botín te llueve.",
  "Tes pièges frappent plus fort et couvrent plus de piste.": "Tus trampas pegan más fuerte y cubren más pista.",
  "Tes tirs font deux fois plus de dégâts.": "Tus disparos hacen el doble de daño.",
  "Tes tirs font nettement plus de dégâts.": "Tus disparos hacen bastante más daño.",
  "Tes tirs font plus de dégâts.": "Tus disparos hacen más daño.",
  "Tes tirs traversent deux bad vibes de plus.": "Tus disparos atraviesan dos bad vibes más.",
  "Tes tirs traversent quatre bad vibes de plus.": "Tus disparos atraviesan cuatro bad vibes más.",
  "Tes tirs traversent six bad vibes de plus.": "Tus disparos atraviesan seis bad vibes más.",
  "Tes tirs vont plus vite, traversent plus et frappent fort.": "Tus disparos van más rápido, atraviesan más y pegan fuerte.",
  "Tient la ligne et attire les bad vibes. Lent.": "Aguanta la línea y atrae a las bad vibes. Lento.",
  "Tir automatique": "Disparo automático",
  "Tire": "Dispara",
  "Tire sur les doubles croches {steps}": "Dispara en las semicorcheas {steps}",
  "Tire sur les doubles croches {steps}, une mesure sur {bars}": {
    "one": "Dispara en las semicorcheas {steps}, un compás de cada {bars}",
    "many": "Dispara en las semicorcheas {steps}, un compás de cada {bars}",
    "other": "Dispara en las semicorcheas {steps}, un compás de cada {bars}"
  },
  "Tirer": "Disparar",
  "Toi": "Tú",
  "Toi · hôte": "Tú · anfitrión",
  "Ton Kiff au max double la force de ta bonne humeur.": "Tu Disfrute al máximo duplica la fuerza de tu buen humor.",
  "Ton Kiff fait frapper ta bonne humeur nettement plus fort.": "Tu Disfrute hace que tu buen humor golpee bastante más fuerte.",
  "Ton Kiff fait frapper ta bonne humeur plus fort.": "Tu Disfrute hace que tu buen humor golpee más fuerte.",
  "Ton aura s’élargit nettement.": "Tu aura se ensancha bastante.",
  "Ton aura s’élargit.": "Tu aura se ensancha.",
  "Ton aura s’étend de moitié.": "Tu aura crece la mitad más.",
  "Ton avis": "Tu opinión",
  "Ton avis sera public sur GitHub. N’y mets rien de personnel.": "Tu opinión será pública en GitHub. No pongas nada personal.",
  "Ton dash revient bien plus vite.": "Tu impulso vuelve mucho antes.",
  "Ton dash revient nettement plus vite.": "Tu impulso vuelve bastante antes.",
  "Ton dash revient plus vite.": "Tu impulso vuelve antes.",
  "Ton message était trop long pour le lien, sa fin a été coupée. Copie-le en entier pour le coller sur GitHub.": "Tu mensaje era demasiado largo para el enlace y se ha cortado el final. Cópialo entero para pegarlo en GitHub.",
  "Ton navigateur a bloqué le nouvel onglet. Réessaie, ou copie ton avis pour ne pas le perdre.": "Tu navegador ha bloqueado la nueva pestaña. Inténtalo otra vez o copia tu opinión para no perderla.",
  "Ton onglet a pris trop de retard.": "Tu pestaña se ha quedado demasiado atrás.",
  "Totem": "Tótem",
  "Totem sono": "Tótem Sonoro",
  "Touche le bouton de ta spéciale": "Toca el botón de tu especial",
  "Touche le bouton du dash": "Toca el botón del impulso",
  "Touche le bouton du piège pour le poser": "Toca el botón de la trampa para ponerla",
  "Touche le bouton d’un piège pour le poser à tes pieds": "Toca el botón de una trampa para ponerla a tus pies",
  "Toucher": "Tocar",
  "Toucher son bouton": "Tocar su botón",
  "Touches par défaut remises.": "Teclas por defecto restauradas.",
  "Toujours là : Start pour la pause, la croix pour les gestes, A et B dans les menus.": "Siempre disponibles: Start para la pausa, la cruceta para los gestos, A y B en los menús.",
  "Toujours là : Échap pour la pause, 1 à 5 pour les pièges, les flèches et Entrée dans les menus.": "Siempre disponibles: Esc para la pausa, 1 a 5 para las trampas, las flechas y Enter en los menús.",
  "Tourne ton téléphone": "Gira tu teléfono",
  "Trois cerceaux, chacun frappe comme ta spéciale.": "Tres aros, y cada uno golpea como tu especial.",
  "Trouve ton crew": "Encuentra a tu crew",
  "Tu as rejoint le salon {code}.": "Te has unido a la sala {code}.",
  "Tu attires les vibes de bien plus loin.": "Atraes las vibes desde mucho más lejos.",
  "Tu attires les vibes de plus loin.": "Atraes las vibes desde más lejos.",
  "Tu attires les vibes de très loin.": "Atraes las vibes desde muy lejos.",
  "Tu attires les vibes, tires plus et frappes plus fort.": "Atraes las vibes, disparas más y pegas más fuerte.",
  "Tu deviens plus solide et tu glisses plus vite.": "Te vuelves más resistente y te deslizas más rápido.",
  "Tu fais venir les porteurs de loot deux fois plus souvent.": "Los portadores de botín vienen el doble de a menudo.",
  "Tu fais venir les porteurs de loot plus souvent.": "Los portadores de botín vienen más a menudo.",
  "Tu fais venir les porteurs de loot trois fois plus souvent.": "Los portadores de botín vienen el triple de a menudo.",
  "Tu files plus vite ; ta traînée freine plus et soigne mieux.": "Vas más rápido; tu estela frena más y cura mejor.",
  "Tu fonces devant toi, intouchable, et les bad vibes alentour ne voient plus que toi.": "Te lanzas hacia delante, intocable, y las bad vibes de alrededor solo te ven a ti.",
  "Tu gagnes 120 points de vie maximum.": "Ganas 120 puntos de vida máxima.",
  "Tu gagnes 40 points de vie maximum.": "Ganas 40 puntos de vida máxima.",
  "Tu gagnes 80 points de vie maximum.": "Ganas 80 puntos de vida máxima.",
  "Tu laisses les autres joueurs : ton personnage reste immobile et le set continue sans toi.": "Dejas a los demás: tu personaje se queda quieto y el set sigue sin ti.",
  "Tu libères une onde de lumière qui repousse les bad vibes autour de toi.": "Liberas una onda de luz que aparta a las bad vibes de tu alrededor.",
  "Tu marches au stick droit et tu vises au gauche.": "Andas con el stick derecho y apuntas con el izquierdo.",
  "Tu marches au stick gauche et tu vises au droit.": "Andas con el stick izquierdo y apuntas con el derecho.",
  "Tu peux enchaîner deux dashs de plus.": "Puedes encadenar dos impulsos más.",
  "Tu peux enchaîner trois dashs de plus.": "Puedes encadenar tres impulsos más.",
  "Tu peux enchaîner un dash de plus.": "Puedes encadenar un impulso más.",
  "Tu peux poser deux pièges de plus.": "Puedes poner dos trampas más.",
  "Tu peux poser quatre pièges de plus.": "Puedes poner cuatro trampas más.",
  "Tu peux poser six pièges de plus.": "Puedes poner seis trampas más.",
  "Tu ramasses les loots de bien plus loin.": "Recoges el botín desde mucho más lejos.",
  "Tu ramasses les loots de plus loin.": "Recoges el botín desde más lejos.",
  "Tu ramasses les loots de très loin.": "Recoges el botín desde muy lejos.",
  "Tu rentres avant le sunrise : la partie s’arrête ici, sans score.": "Te vas antes del sunrise: la partida acaba aquí, sin puntuación.",
  "Tu roules vite ; ta traînée freine les bad vibes et soigne.": "Ruedas rápido; tu estela frena a las bad vibes y cura.",
  "Tu sais jouer. Tiens jusqu’au sunrise !": "Ya sabes jugar. ¡Aguanta hasta el sunrise!",
  "Tu soignes ceux qui sont près de toi et tu répares un peu la scène.": "Curas a quienes están cerca de ti y reparas un poco el escenario.",
  "Tu te déplaces bien plus vite.": "Te mueves mucho más rápido.",
  "Tu te déplaces nettement plus vite.": "Te mueves bastante más rápido.",
  "Tu te déplaces plus vite.": "Te mueves más rápido.",
  "Tu tires bien plus souvent.": "Disparas mucho más a menudo.",
  "Tu tires deux projectiles de plus.": "Disparas dos proyectiles más.",
  "Tu tires nettement plus souvent.": "Disparas bastante más a menudo.",
  "Tu tires plus souvent et ta spéciale revient plus vite.": "Disparas más a menudo y tu especial vuelve antes.",
  "Tu tires plus souvent.": "Disparas más a menudo.",
  "Tu tires quatre projectiles de plus.": "Disparas cuatro proyectiles más.",
  "Tu tires six projectiles de plus.": "Disparas seis proyectiles más.",
  "Un bâton, à jeter au feu": "Un leño, para echar al fuego",
  "Un cerceau tourne autour de toi, repousse et s’élargit.": "Un aro gira a tu alrededor, empuja y se agranda.",
  "Un joueur": "Un jugador",
  "Un set, jusqu’au sunrise": "Un set, hasta el sunrise",
  "Une brume qui te soigne": "Una bruma que te cura",
  "Une idée, un bug ? Dis-le-nous": "¿Una idea, un bug? Cuéntanoslo",
  "Une note par coup porté": "Una nota por cada golpe",
  "Une onde de choc par kick": "Una onda expansiva en cada kick",
  "Une scène": "Un escenario",
  "Une vague part de toi, ralentit les bad vibes et fait courir et tirer plus vite toute l’équipe.": "Una ola sale de ti, frena a las bad vibes y hace correr y disparar más rápido a todo el equipo.",
  "Ventilateur brumisant": "Ventilador de Bruma",
  "Verr. maj": "Bloq Mayús",
  "Vers la bad vibe à portée": "Hacia la bad vibe a tu alcance",
  "Vibes": "Vibes",
  "Vie": "Vida",
  "Vie de la scène": "Vida del escenario",
  "Viser": "Apuntar",
  "Viser et tirer": "Apuntar y disparar",
  "Visée automatique": "Puntería automática",
  "Vitesse": "Velocidad",
  "Volume à fond": "Volumen a Tope",
  "annuler": "cancelar",
  "apprendre": "aprender",
  "aucune": "ninguna",
  "avant : {score}": "antes: {score}",
  "avec {first} ou {second}, il fusionne": "con {first} o {second}, se fusiona",
  "avec {upgrade}, devient {fusion}": "con {upgrade}, se convierte en {fusion}",
  "changer": "cambiar",
  "choisir": "elegir",
  "classe": "clase",
  "classe, scène": "clase, escenario",
  "départ {stage} · {count} scènes · {length}": "desde {stage} · {count} escenarios · {length}",
  "fermer": "cerrar",
  "lancer": "lanzar",
  "mode": "modo",
  "naviguer": "navegar",
  "niv. {level}": "niv. {level}",
  "ou rejoins le salon d’un ami": "o únete a la sala de un amigo",
  "pose le piège à tes pieds": "pon la trampa a tus pies",
  "quitter": "salir",
  "quitter sa place": "dejar su sitio",
  "recharge {duration}": "recarga {duration}",
  "rejoindre": "unirse",
  "reprendre": "continuar",
  "retour": "atrás",
  "sans fin": "sin fin",
  "scène": "escenario",
  "son": "sonido",
  "tant que vous tenez": "mientras aguantéis",
  "valider": "confirmar",
  "vider": "vaciar",
  "{action} : appuie sur un bouton de la manette.": "{action}: pulsa un botón del mando.",
  "{action} : appuie sur une touche, un bouton de la souris ou la molette.": "{action}: pulsa una tecla, un botón del ratón o la rueda.",
  "{action} : case vidée.": "{action}: casilla vaciada.",
  "{action}, touche {number} : {key}": "{action}, casilla {number}: {key}",
  "{count} alliés soignés": {
    "one": "{count} aliado curado",
    "many": "{count} aliados curados",
    "other": "{count} aliados curados"
  },
  "{count} bad vibes": {
    "one": "{count} bad vibe",
    "many": "{count} bad vibes",
    "other": "{count} bad vibes"
  },
  "{count} boss": {
    "one": "{count} jefe",
    "many": "{count} jefes",
    "other": "{count} jefes"
  },
  "{count} cartes": {
    "one": "{count} carta",
    "many": "{count} cartas",
    "other": "{count} cartas"
  },
  "{count} vibes": {
    "one": "{count} vibe",
    "many": "{count} vibes",
    "other": "{count} vibes"
  },
  "{count} visites": {
    "one": "{count} visita",
    "many": "{count} visitas",
    "other": "{count} visitas"
  },
  "{hp} sur {maxHp}": "{hp} de {maxHp}",
  "{key} va à {action} et quitte {other}.": "{key} pasa a {action} y deja {other}.",
  "{key} va à {action}, {other} prend {old}.": "{key} pasa a {action}, {other} toma {old}.",
  "{key} va à {action}.": "{key} pasa a {action}.",
  "{names} et {last}": "{names} y {last}",
  "{name} : {card}": "{name}: {card}",
  "{name} : {description}": "{name}: {description}",
  "{name} a quitté le set": "{name} ha dejado el set",
  "{name} choisit…": "{name} está eligiendo…",
  "{name}, dans le jeu complet": "{name}, en el juego completo",
  "{percent} %": "{percent} %",
  "{percent} %": "{percent} %",
  "{plugged} enceintes branchées sur {total}": {
    "one": "{plugged} de {total} altavoces conectados",
    "many": "{plugged} de {total} altavoces conectados",
    "other": "{plugged} de {total} altavoces conectados"
  },
  "{role}, que tes agrès ne font pas encore": "{role}, algo que tus aparatos aún no hacen",
  "{skill} : en recharge": "{skill}: recargando",
  "{skill} : prête": "{skill}: lista",
  "{taken}/{capacity}": "{taken}/{capacity}",
  "{value} sur {max}": "{value} de {max}",
  "{weapon} + {upgrade}": "{weapon} + {upgrade}",
  "{weapon}, niveau {level}": "{weapon}, nivel {level}",
  "À distance": "A distancia",
  "À fond": "A tope",
  "À plusieurs": "Con amigos",
  "À terre": "En el suelo",
  "Échap": "Esc",
  "Éclats de rire": "Carcajadas",
  "Écran titre": "Pantalla de título",
  "Écris ton avis avant de l’envoyer.": "Escribe tu opinión antes de enviarla.",
  "Équilibrage": "Equilibrio",
  "Éventails de feu": "Abanicos de Fuego",
  "≈ {minutes} min": "≈ {minutes} min"
}
